<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">高級方案專屬</h1>
                        <h2>Trinka Windows 桌面版</h2>
                        <p>在 Windows 桌面上進行文法修正與語言潤飾。</p>
                        <div class="btn-group align-items-end">
                            <div [innerHTML]="downloadLink"></div>
                            <span class="beta-badge">Beta 測試版</span>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/native-app/windows-native-app.svg" width="489" height="563" alt="native app" priority />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="data-card list-wrapper-style-2 section-pd pb-0 bg-light-purple">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-12">
                <div class="trinka-title mb-0 text-white position-relative">
                    <h2 class="text-white mb-3 text-center">為何選擇 Trinka Windows 桌面版應用程式：</h2>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <div class="media">
                        <div class="media-left">
                            <img src="/assets/images/grammar-checker-icon.svg" width="40" height="38" alt="Grammar Checker" />
                        </div>
                        <div class="media-body">
                            <h3>即時文法檢查，無須切換視窗</h3>
                        </div>
                    </div>
                    <p>在您書寫的任何位置自動提供建議，無需複製貼上，格式也不會遺失。
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <!-- <span class="beta-badges">Coming Soon</span> -->
                    <div class="media">
                        <div class="media-left">
                            <svg width="40" height="40" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M31.47 6.68999L16.5 12.33C13.05 13.62 10.23 17.7 10.23 21.36V43.65C10.23 47.19 12.57 51.84 15.42 53.97L28.32 63.6C32.55 66.78 39.51 66.78 43.74 63.6L56.64 53.97C59.49 51.84 61.83 47.19 61.83 43.65V21.36C61.83 17.67 59.01 13.59 55.56 12.3L40.59 6.68999C38.04 5.75999 33.96 5.75999 31.47 6.68999Z" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M23.993 2.67432L9.19709 8.127C5.78721 9.37415 3 13.3186 3 16.8571V38.4068" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M27.15 35.61L31.98 40.44L44.88 27.54" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="media-body">
                            <h3>更快速、更輕盈的體驗
                            </h3>
                        </div>
                    </div>
                    <p>Windows 桌面應用程式運行更快、佔用資源更少，同時仍提供 Trinka 一貫的高級文法修正功能。
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-12 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <div class="media">
                        <div class="media-left">
                            <svg fill="#7A28A0" height="40px" width="40px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" stroke="#7A28A0"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <g> <path d="M501.574,213.627H315.268V166.56c0-5.758-4.669-10.426-10.426-10.426h-31.228c-1.744-5.142-3.829-10.164-6.244-15.031 l22.094-22.095c4.071-4.071,4.071-10.673,0-14.744l-40.732-40.732c-4.072-4.071-10.672-4.071-14.745,0l-22.094,22.094 c-4.868-2.415-9.89-4.501-15.031-6.244V48.154c0-5.758-4.669-10.426-10.426-10.426h-57.605c-5.757,0-10.426,4.668-10.426,10.426 v31.228c-5.142,1.743-10.163,3.829-15.031,6.245L81.281,63.532c-4.071-4.07-10.671-4.071-14.745,0l-40.732,40.732 c-4.071,4.071-4.071,10.673,0,14.744l22.094,22.095c-2.414,4.867-4.5,9.889-6.244,15.031H10.426 C4.669,156.134,0,160.801,0,166.56v57.604c0,5.758,4.669,10.426,10.426,10.426h31.228c1.743,5.142,3.829,10.163,6.244,15.031 l-22.094,22.095c-4.071,4.071-4.071,10.673,0,14.744l40.732,40.732c4.072,4.071,10.672,4.071,14.745,0l22.094-22.094 c4.868,2.415,9.89,4.501,15.031,6.244v31.228c0,5.758,4.669,10.426,10.426,10.426h28.691v110.851 c0,5.758,4.669,10.426,10.426,10.426h333.626c5.757,0,10.426-4.668,10.426-10.426V224.053 C512,218.295,507.331,213.627,501.574,213.627z M448.423,234.478v20.852H178.374v-20.852H448.423z M157.525,332.145h-18.267 v-0.002v-28.536c0-4.725-3.178-8.859-7.743-10.074c-8.671-2.309-17.012-5.775-24.789-10.3c-4.087-2.378-9.268-1.707-12.615,1.639 l-20.201,20.203l-25.987-25.987l20.202-20.203c3.346-3.346,4.018-8.525,1.639-12.615c-4.524-7.776-7.989-16.116-10.3-24.79 c-1.217-4.565-5.351-7.742-10.074-7.742H20.852v-36.752h28.536c4.724,0,8.858-3.177,10.074-7.742 c2.311-8.674,5.776-17.015,10.3-24.79c2.379-4.09,1.707-9.27-1.639-12.615l-20.202-20.203l25.987-25.985l20.202,20.202 c3.346,3.346,8.527,4.018,12.615,1.639c7.777-4.524,16.117-7.989,24.79-10.3c4.565-1.217,7.742-5.349,7.742-10.074V58.579h36.752 v28.536c0,4.725,3.177,8.859,7.743,10.074c8.671,2.309,17.012,5.775,24.789,10.3c4.087,2.378,9.268,1.708,12.615-1.639 l20.202-20.202l25.987,25.987l-20.202,20.203c-3.346,3.346-4.018,8.525-1.639,12.615c4.524,7.776,7.988,16.116,10.3,24.79 c1.217,4.565,5.351,7.742,10.074,7.742h28.536v36.642h-67.944c1.555-5.831,2.391-11.951,2.391-18.266 c0-39.276-31.953-71.229-71.229-71.229c-39.276,0-71.229,31.953-71.229,71.229c0,39.239,31.894,71.166,71.119,71.226V332.145z M157.523,224.053v21.684c-27.726-0.06-50.267-22.633-50.267-50.374c0-27.779,22.6-50.378,50.378-50.378 c27.777,0,50.378,22.599,50.378,50.378c0.001,6.442-1.225,12.6-3.442,18.265h-36.621 C162.191,213.627,157.523,218.295,157.523,224.053z M491.148,453.421H178.374V276.182h312.774V453.421z M491.148,255.33h-21.873 v-20.852h21.873V255.33z"></path> <path d="M392.609,325.911c1.907,1.493,4.171,2.217,6.419,2.217c3.095,0,6.16-1.373,8.217-3.999l0.587-0.751 c3.549-4.534,2.751-11.087-1.783-14.637c-4.532-3.548-11.085-2.751-14.636,1.782l-0.587,0.751 C387.277,315.808,388.076,322.361,392.609,325.911z"></path> <path d="M315.766,420.262c1.98,2.442,4.955,3.858,8.097,3.858c0.029,0,0.06,0,0.09,0c3.174-0.027,6.162-1.499,8.119-3.997 l51.33-65.548c3.55-4.533,2.753-11.087-1.781-14.637c-4.532-3.551-11.086-2.752-14.636,1.781l-43.267,55.251l-34.158-42.102 c-3.628-4.472-10.192-5.156-14.665-1.527c-4.471,3.627-5.155,10.193-1.527,14.665L315.766,420.262z"></path> </g> </g> </g> </g></svg>
                        </div>
                        <div class="media-body">
                            <h3>一套工具，適用所有 Windows 應用
                            </h3>
                        </div>
                    </div>
                    <p>無論您使用哪種 Windows 軟體進行寫作，Trinka 都能隨時提供專業協助，是您寫作工作的全方位助手。
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="howItWorks section-pd list-wrapper-style-2 bg-light-purple">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#youtubeModalPopup" id="VewiVideoSection">
                        <img src="/assets/images/yt-thumbnail/WindowsAppThumbnail.webp" width="800" height="450" alt="ms word" class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0">
                        <h2>觀看教學</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p>需要協助安裝，或想了解如何使用 Trinka Windows 桌面應用程式進行文法修正嗎？</p>
                        <p>立即觀看操作教學影片，了解如何在Windows作業系統上使用Word的Trinka桌面板</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pb-0">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinka Windows 桌面應用程式主要功色</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-70">Trinka for Windows 是一款桌面應用程式，能在您使用各種軟體寫作時，提供專業的文法修正與建議。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="/assets/images/grammar-checker-icon.svg" width="40" height="40" alt="Grammar Checker" />
                    <h3>英文文法檢查</h3>
                    <p>在各種 Windows 應用程式（如 MS Word）中，即時提供寫作建議與高級文法檢查。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="/assets/images/PublicationReadiness.svg" width="40" height="40" alt="Paraphraser">
                    <h3>技術性拼字檢查</h3>
                    <p>透過上下文語意進行拼字檢查，減少拼寫錯誤並提升整體寫作品質。
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="/assets/images/error-highlight-icon.svg" width="40" height="40" alt="Interactive Error Highlighting">
                    <h3>互動式錯誤提示</h3>
                    <p>文件中的文法錯誤會直接在頁面上清楚標示，相關建議則會顯示在右側專用面板中，方便您輕鬆查看。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 25" fill="none">
                        <path d="M15 14.25H7C6.59 14.25 6.25 13.91 6.25 13.5C6.25 13.09 6.59 12.75 7 12.75H15C15.41 12.75 15.75 13.09 15.75 13.5C15.75 13.91 15.41 14.25 15 14.25Z" fill="#7A28A0"/>
                        <path d="M16.029 10.5803H7.0882C6.62998 10.5803 6.25 10.2403 6.25 9.83032C6.25 9.42032 6.62998 9.08032 7.0882 9.08032H16.029C16.4872 9.08032 16.8672 9.42032 16.8672 9.83032C16.8672 10.2403 16.4872 10.5803 16.029 10.5803Z" fill="#7A28A0"/>
                        <path d="M12 18.25H7C6.59 18.25 6.25 17.91 6.25 17.5C6.25 17.09 6.59 16.75 7 16.75H12C12.41 16.75 12.75 17.09 12.75 17.5C12.75 17.91 12.41 18.25 12 18.25Z" fill="#7A28A0"/>
                        <path d="M15 23.25H9C3.38 23.25 2.25 20.6 2.25 16.32V10.15C2.25 5.41 3.85 3.48 7.96 3.25H16C16.01 3.25 16.03 3.25 16.04 3.25C20.15 3.48 21.75 5.41 21.75 10.15V16.32C21.75 20.6 20.62 23.25 15 23.25ZM8 4.75C5.2 4.91 3.75 5.79 3.75 10.15V16.32C3.75 20.15 4.48 21.75 9 21.75H15C19.52 21.75 20.25 20.15 20.25 16.32V10.15C20.25 5.8 18.81 4.91 15.98 4.75H8Z" fill="#7A28A0"/>
                    </svg>
                    <h3>寫作建議</h3>
                    <p>提升寫作風格、連貫性及整體表達，幫助您清晰傳達內容。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 25" fill="none">
                        <path d="M12 5H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 10H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M21 15H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M21 20H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <h3>句子結構、用法與風格</h3>
                    <p>改善句子結構與用法，使文字易於理解且風格正式。
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 25" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.928 1.27032C19.3169 1.47798 17.1419 2.21843 15.0947 2.91565L11.3725 4.18343L7.23548 2.71954L3.09837 1.25554L3.06881 4.09998L3.03915 6.94443L1.76137 7.38887L0.483592 7.83332L0.455147 16.031C0.428592 23.6418 0.499864 24.2778 0.499864 24.2778C0.499864 24.2778 3.11648 23.6045 6.4207 22.5075L12.0391 20.6423L17.3169 22.3242C20.2197 23.2493 22.8071 24.0768 23.0669 24.163L23.5391 24.3199V16.2308V8.14176L22.4836 7.82465L21.428 7.50754V4.33154C21.428 1.28265 21.428 0.722229 21.428 0.722229C21.428 0.722229 20.5391 1.06265 19.928 1.27032ZM20.8888 4.44445C20.8888 6.59167 20.8888 7.33334 20.8888 7.33334C20.8888 7.33334 12.4043 4.65354 12.295 4.56376C12.2106 4.4942 20.8888 1.50001 20.8888 1.50001C20.8888 1.50001 20.8888 1.8889 20.8888 4.44445ZM11.5391 12.4908V20.2036L6.3447 21.9352C3.4877 22.8875 1.05542 23.6667 1.05542 23.6667C1.05542 23.6667 0.983592 20.1958 0.983592 15.9536V8.24076L6.12248 6.51798C8.94893 5.57054 11.3239 4.79132 11.4003 4.78654C11.5101 4.77954 11.5391 6.38976 11.5391 12.4908Z" fill="#7A28A0"/>
                        <path d="M5.60512 11.9638C5.8266 11.9016 6.04846 11.839 6.27068 11.7761C6.28327 12.9168 6.29586 14.0583 6.30846 15.2005C6.3129 15.565 6.24401 15.9072 6.09957 16.2261C5.95623 16.5427 5.7529 16.8161 5.48846 17.045C5.22512 17.2727 4.91401 17.4316 4.55734 17.5238C4.20179 17.615 3.88957 17.615 3.6229 17.525C3.35734 17.4338 3.15068 17.2694 3.00401 17.0316C2.85734 16.7927 2.78401 16.4938 2.7829 16.135C2.78142 15.0098 2.77957 13.885 2.77734 12.7605C2.99883 12.6983 3.22031 12.6361 3.44179 12.5738C3.44623 13.6812 3.44994 14.7879 3.4529 15.8938C3.4529 16.1261 3.49734 16.3227 3.58623 16.4794C3.67734 16.6372 3.80401 16.7461 3.96845 16.8083C4.1329 16.8672 4.32734 16.8694 4.55179 16.8105C4.77846 16.7527 4.9729 16.6494 5.13512 16.505C5.29957 16.3561 5.42401 16.1805 5.50957 15.975C5.59623 15.7705 5.63845 15.5494 5.63623 15.315C5.62586 14.1979 5.61549 13.0809 5.60512 11.9638Z" fill="#7A28A0"/>
                        <path d="M6.87845 16.8416C6.85623 15.1024 6.83401 13.3631 6.81179 11.6238C7.03253 11.5616 7.25327 11.499 7.47401 11.4361C7.48586 12.2694 7.49808 13.1024 7.51068 13.935C7.52846 13.9298 7.5466 13.925 7.56512 13.9205C8.16883 12.9175 8.77105 11.9112 9.37179 10.9016C9.65031 10.8231 9.92882 10.745 10.2073 10.6672C9.63105 11.6242 9.05327 12.5787 8.47401 13.5305C9.09031 14.3364 9.70846 15.145 10.3285 15.9561C10.0588 16.0257 9.78883 16.0953 9.51846 16.165C9.02512 15.5057 8.53253 14.8479 8.04068 14.1916C7.86957 14.4753 7.69845 14.7587 7.52734 15.0416C7.53475 15.5846 7.54253 16.1272 7.55068 16.6694C7.32623 16.7272 7.10216 16.7846 6.87845 16.8416Z" fill="#7A28A0"/>
                        <path d="M16.4898 11.4536C16.7205 11.515 16.9511 11.5768 17.1817 11.639C17.1878 12.7796 17.194 13.9206 17.2001 15.0619C17.2011 15.4253 17.1285 15.729 16.978 15.9708C16.8286 16.2106 16.6168 16.3761 16.3445 16.4651C16.0713 16.5541 15.7509 16.5509 15.3825 16.4556C15.0161 16.3604 14.6948 16.1981 14.4205 15.9666C14.1472 15.7342 13.9344 15.4578 13.7829 15.1373C13.6325 14.8159 13.5567 14.4714 13.5567 14.1059C13.5561 12.9597 13.5554 11.8135 13.5547 10.6672C13.7839 10.7287 14.0135 10.7901 14.2434 10.8515C14.2448 11.9761 14.2462 13.1 14.2475 14.2232C14.2486 14.4599 14.2936 14.6818 14.3847 14.8892C14.4788 15.0965 14.6088 15.2756 14.7787 15.4253C14.9476 15.5729 15.1481 15.6776 15.3805 15.7373C15.6138 15.7981 15.8144 15.7981 15.9822 15.7384C16.1531 15.6776 16.2821 15.5677 16.3711 15.4075C16.4622 15.2494 16.5062 15.0515 16.5052 14.8159C16.5004 13.6955 16.4953 12.5747 16.4898 11.4536Z" fill="white"/>
                        <path d="M20.2468 13.818C20.2212 13.5719 20.1209 13.3614 19.947 13.1834C19.773 13.0033 19.555 12.8798 19.293 12.8096C19.1057 12.7604 18.945 12.7499 18.8079 12.7813C18.6718 12.8107 18.5653 12.8735 18.4906 12.9698C18.4169 13.0651 18.3811 13.1866 18.3821 13.3342C18.3832 13.4567 18.4088 13.5698 18.4599 13.6724C18.5131 13.7761 18.5807 13.8682 18.6646 13.952C18.7506 14.0337 18.8417 14.107 18.9389 14.173C19.0361 14.2379 19.1292 14.2944 19.2183 14.3436C19.3684 14.4267 19.5181 14.5101 19.6676 14.5939C19.8139 14.6724 19.9633 14.7667 20.1179 14.8766C20.2724 14.9866 20.4157 15.1154 20.5477 15.263C20.6807 15.4106 20.7882 15.5782 20.8701 15.7667C20.954 15.9551 20.997 16.1646 20.999 16.3981C21.0021 16.6912 20.9386 16.9342 20.8056 17.1268C20.6746 17.3195 20.4832 17.4483 20.2294 17.5143C19.9787 17.5813 19.6727 17.5677 19.3135 17.4745C18.9686 17.3855 18.6708 17.2462 18.419 17.0567C18.1662 16.8682 17.9687 16.6431 17.8254 16.3782C17.6821 16.1132 17.6013 15.8211 17.5849 15.5049C17.8162 15.5656 18.0478 15.626 18.2798 15.686C18.2952 15.8776 18.3494 16.0483 18.4446 16.197C18.5408 16.3457 18.6636 16.4703 18.812 16.5687C18.9614 16.6672 19.1251 16.7394 19.3042 16.7865C19.4997 16.8368 19.6727 16.8473 19.8252 16.8179C19.9777 16.7865 20.0984 16.7206 20.1854 16.619C20.2724 16.5153 20.3154 16.3803 20.3144 16.2117C20.3123 16.0577 20.2724 15.9216 20.1936 15.8033C20.1168 15.686 20.0125 15.5771 19.8804 15.4787C19.7505 15.3813 19.6021 15.285 19.4383 15.1928C19.2568 15.0895 19.076 14.9866 18.8959 14.8839C18.5275 14.6735 18.2358 14.4295 18.0188 14.1531C17.8039 13.8777 17.6965 13.5573 17.6944 13.197C17.6924 12.8965 17.762 12.6536 17.9042 12.4683C18.0454 12.284 18.2368 12.1615 18.4804 12.1039C18.7229 12.0431 18.9972 12.0547 19.3032 12.1363C19.6133 12.2191 19.8866 12.3541 20.124 12.5416C20.3635 12.7279 20.5518 12.9478 20.69 13.1991C20.8302 13.4494 20.9038 13.7154 20.912 13.9939C20.6903 13.9353 20.4686 13.8766 20.2468 13.818Z" fill="white"/>
                    </svg>
                    <h3>美式/英式英語切換</h3>
                    <p>可根據目標讀者選擇美式或英式英語風格。
                    </p>
                </div>
            </div>
            
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pb-0">
    <div class="trinka_container container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0 text-left">
                        <h2>支援下列系統版本</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    </div>
                    <ul class="bullet-list">
                        <li>支援 Windows 10 及更新版本</li>
                        <li>支援 MS Word 與 Outlook 2011 及以上版本</li>
                        <li>其他 Windows 應用程式支援功能即將推出</li>
                    </ul>
                    <div class="btn-group align-items-end">
                        <div [innerHTML]="downloadLink"></div>
                        <span class="beta-badge">Beta 測試版</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="/assets/images/native-app/compliance-desktop-app.svg"  width="456" height="424" alt="compare" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<app-grammar-without-internet [windowsButton]="true"></app-grammar-without-internet>

<section class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Trinka 桌面應用程式免費嗎？
                                    </a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            僅限高級 及 高級 Plus 訂閱用戶使用。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true" aria-controls="QuestionTwoContent">
                                        如何在電腦上安裝 Trinka 桌面版？
                                    </a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            請點選下載按鈕下載安裝檔。完成下載後，執行安裝程式並依照畫面指示完成安裝。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true" aria-controls="QuestionThreeContent">
                                        使用 Trinka 桌面版的系統需求為何？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 桌面版支援 Windows 10 或更新版本，可順利在大多數基本配置的筆電或桌電上執行。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true" aria-controls="QuestionFourContent">
                                        Trinka Windows 桌面版目前支援哪些軟體？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            目前支援 Microsoft Word 與 Outlook 的撰寫與編輯功能，未來將陸續擴大支援其他軟體。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true" aria-controls="QuestionFiveContent">
                                        Trinka 桌面版支援哪些語言的文法檢查？
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka AI 支援英文文法檢查，包含美式與英式英語。西班牙語文法檢查功能將於日後推出。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true" aria-controls="QuestionSixContent">
                                        如果 Trinka 桌面版無法偵測錯誤，我該怎麼辦？
                                    </a>
                                </div>

                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>請依下列步驟進行檢查與排除：</p>
                                        <ul class="mt-1">
                                            <li>確認安裝是否完成</li>
                                            <li>開啟「開始」選單，搜尋並啟動「Trinka」程式</li>
                                            <li>在工作列右下角找到 Trinka 圖示，雙擊以啟動</li>
                                            <li> 確認您已登入 Trinka 帳號，並訂閱 高級 或 高級 Plus 方案</li>
                                            <li>確認文件已在支援的軟體中開啟（目前僅支援 MS Word）</li>
                                            <li>嘗試重新安裝 Trinka</li>
                                            <li>若問題仍未解決，<a href="mailto:support&#64;trinka&#46;ai" class="text-link">請聯絡 Trinka</a> 客服團隊協助處理</li>

                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true" aria-controls="QuestionSevenContent">
                                        如果錯誤標示不正確，該怎麼辦？
                                    </a>
                                </div>

                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>請確認 Microsoft Word 是否啟用了「修訂模式」。建議在使用 Trinka 桌面版進行文法檢查時關閉修訂模式，以避免標示錯位。如需進一步協助，歡迎聯繫 Trinka 客服團隊。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEightSection">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightSectionContent" aria-expanded="true" aria-controls="QuestionEightSectionContent">
                                        要如何更新 Trinka 桌面版？
                                    </a>
                                </div>

                                <div id="QuestionEightSectionContent" class="collapse" aria-labelledby="QuestionEightSection" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka Windows 桌面版會自動更新，確保您始終使用最新版本及功能。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightContent" aria-expanded="true" aria-controls="QuestionEightContent">
                                        Trinka 桌面版與 MS Word 外掛有何不同？
                                    </a>
                                </div>

                                <div id="QuestionEightContent" class="collapse" aria-labelledby="QuestionEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            Trinka 桌面版速度更快、效能更高，能在多種原生 Windows 軟體中直接使用，保留文件格式，無需複製貼上。
                                        </p>
                                        <p>MS Word 外掛則整合於 Word 環境中，僅支援 Word 本身的文法校正。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionTen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTenContent" aria-expanded="true" aria-controls="QuestionTenContent">
                                        可以同時使用桌面版與 MS Word 外掛嗎？
                                    </a>
                                </div>

                                <div id="QuestionTenContent" class="collapse" aria-labelledby="QuestionTen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            兩者可以同時安裝，但建議同一時間僅啟用其中一種，以避免可能的衝突。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="ListLiners hideWindowsApp">
    <app-trinka-in-other-apps></app-trinka-in-other-apps>
</section>

<div class="modal" id="youtubeModalPopup">
    <div class="modal-dialog modal-dialog-centered modal-lg">
       <div class="modal-content">
          <div class="modal-body no-padding">
             <button type="button" class="btn-close" data-dismiss="modal" (click)="stopAllVideos()"></button>
             <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/u5OE774DAMQ?si=CSbiZjrRLcWpLhw4"
                title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
          </div>
       </div>
    </div>
</div>